import {
  CircularProgress,
  CircularProgressLabel,
  Heading,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react"

import circleAlertIcon from "#/assets/circle-alert.svg"
import { selectDepositAmount, useDappSelector } from "#/redux-state"
import { BITCOIN_MIN_DEPOSIT } from "#/shared/constants"

import DepositModalDivider from "./DepositModalDivider"

export default function DepositModalInsufficient() {
  const depositAmount = useDappSelector(selectDepositAmount)

  return (
    <VStack gap={0}>
      <CircularProgress
        isIndeterminate
        size="140px"
        thickness="4px"
        color="primary.red.100"
        trackColor="primary.white.100"
        mb={8}
      >
        <CircularProgressLabel
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Image src={circleAlertIcon} w="88px" h="88px" />
        </CircularProgressLabel>
      </CircularProgress>
      <Text
        fontSize="48px"
        fontFamily="riforma.bold"
        fontWeight={700}
        lineHeight="56px"
        letterSpacing="-0.48px"
        color="primary.red.100"
        mb={4}
      >
        Insufficient BTC
      </Text>
      <Text variant="body" fontWeight={500} fontFamily="riforma.medium">
        Looks like you deposited less then the minimum of <br />
        {BITCOIN_MIN_DEPOSIT} BTC. Your funds are going to be locked for a{" "}
        <br />
        period of 9 months, please reach out to us on Discord for further
        instructions.
      </Text>
      <DepositModalDivider />
      <VStack gap={0}>
        <Heading variant="h2" color="primary.black.50">
          {depositAmount} BTC
        </Heading>
        <Text
          variant="body"
          color="primary.black.50"
          fontWeight={500}
          fontFamily="riforma.medium"
          lineHeight={0}
          mt={1}
        >
          incoming...
        </Text>
      </VStack>
    </VStack>
  )
}
